const Messages = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.5002 9.5H12.835C13.5713 9.5 14.1683 8.90305 14.1683 8.16667V3.83333C14.1683 3.09695 13.5713 2.5 12.835 2.5H6.00163C5.26525 2.5 4.66829 3.09695 4.66829 3.83333V5.16667M10.1683 5.16667H3.16829C2.43191 5.16667 1.83496 5.76362 1.83496 6.5V10.8333C1.83496 11.5697 2.43191 12.1667 3.16829 12.1667H4.00163V13.8333L7.00163 12.1667H10.1683C10.9047 12.1667 11.5016 11.5697 11.5016 10.8333V6.5C11.5016 5.76362 10.9047 5.16667 10.1683 5.16667Z"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Messages
